export default __webpack_public_path__ + "static/media/newMsg.9626fda6.png";